import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=4851caaf&scoped=true&"
import script from "./Sync.vue?vue&type=script&lang=ts&"
export * from "./Sync.vue?vue&type=script&lang=ts&"
import style0 from "./Sync.vue?vue&type=style&index=0&id=4851caaf&lang=scss&scoped=true&"
import style1 from "./Sync.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851caaf",
  null
  
)

export default component.exports